import PropTypes from 'prop-types';

export default {
  $location: PropTypes.shape({
    path: PropTypes.func.isRequired,
    host: PropTypes.func.isRequired,
    search: PropTypes.func.isRequired,
  }).isRequired,
  $rootScope: PropTypes.shape({
    $apply: PropTypes.func.isRequired,
    $digest: PropTypes.func.isRequired,
    matchMedia: PropTypes.shape({
      xs: PropTypes.bool,
      sm: PropTypes.bool,
      md: PropTypes.bool,
      lg: PropTypes.bool,
      ipadLandscape: PropTypes.bool,
      xl: PropTypes.bool,
    }).isRequired,
    metadata: PropTypes.shape({
      image_twitter: PropTypes.string.isRequired,
      image_facebook: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  $routeParams: PropTypes.shape({}).isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
    marketingCustomPage: PropTypes.func,
  }).isRequired,
  ResyAmexConfig: PropTypes.shape({
    baseRequestUrl: PropTypes.string.isRequired,
  }).isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  isNonUS: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
};
